<template>
  <div class="row">
    <div class="col tab">
      <div class="d-flex about">
        <div class="about-titr">
          <h5>امتیاز</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Point",
};
</script>